<script setup lang="ts">
import type { MemorialGiftDTO } from '@/composables/memorize/memorize'
import { computed, type PropType, type Ref } from 'vue'
// import { Vue3Lottie } from 'vue3-lottie'

const props = defineProps({
  gift: {
    type: Object as PropType<MemorialGiftDTO | undefined>,
    required: true
  },
  isPreview: {
    type: Boolean,
    required: false,
    default: true
  },
  size: {
    type: Number,
    required: false,
    default: 16
  },
  clickable: {
    type: Boolean,
    required: false,
    default: false
  }
})

const myGift: Ref<MemorialGiftDTO | undefined> = computed(() => {
  return props.gift
})

function onClicked() {
  if (props.clickable) {
  }
}
</script>
<template>
  <div
    v-if="myGift?.type !== 'lottie'"
    h-full
    w-full
    w-16
    h-16
    :class="[`w-${props.size}`, `h-${props.size}`]"
    flex-r-center>
    <div v-if="myGift === undefined" h-full w-full></div>
    <img
      @click="onClicked"
      v-if="
        (myGift?.type == 'pic' || props.isPreview) &&
        (props.isPreview ? myGift?.file?.url : myGift?.file?.middleQuality || myGift?.file?.url)
      "
      :src="props.isPreview ? myGift?.file?.url : myGift?.file?.middleQuality || myGift?.file?.url"
      :class="[`w-${props.size}`, `h-${props.size}`]"
      class="w-16 h-16 object-contain" />
    <video
      v-if="myGift?.type == 'video' && !props.isPreview && myGift?.file?.url"
      :src="myGift?.file?.url"
      class="w-16 h-16 object-contain"
      :class="[`w-${props.size}`, `h-${props.size}`]"
      autoplay
      loop
      muted
      playsinline></video>
    <!-- <Vue3Lottie v-if="myGift?.type == 'lottie' && !props.isPreview" :animationLink="myGift?.url" w-34 h-34 overflow-hidden/> -->
  </div>
</template>
<style lang="scss" scoped></style>
